import { useTranslation } from 'react-i18next'

import Text from '../../../../../Text'

import { CALENDAR_SETTINGS_TASK_TYPE_LABEL_SEPARATOR } from './TaskTypesFieldListLabel.constants'

import * as styles from './TaskTypesFieldListLabel.module.css'

function TaskTypesFieldListLabel({ isUsedByTemplate, name }) {
  const { t } = useTranslation()

  return (
    <>
      {name}
      {isUsedByTemplate ? (
        <Text className={styles.hint}>
          {CALENDAR_SETTINGS_TASK_TYPE_LABEL_SEPARATOR}
          {t('CalendarSettings.ProcessStepHintKey')}
        </Text>
      ) : null}
    </>
  )
}

export default TaskTypesFieldListLabel
